import { useEffect } from 'react';

import {
  getCurrentPathName,
  getNavigationPayload,
  setNavigationPayload,
} from '@/utils';
import { useAppDispatch } from '@/store';
import { reportNavigation } from '@/features';

import { useSiteNavigation } from '../components/AiAssistantWidget/Widget/contexts/SiteNavigationContext';

/**
 * This hook is used to track navigation events in the session.
 * It checks if the current URL has changed and dispatches a navigation report action.
 * It also sets a session storage item to keep track of the current URL.
 */

export const useSessionNavigation = () => {
  const dispatch = useAppDispatch();
  const { baseUrl } = useSiteNavigation();

  useEffect(() => {
    const currentPayload = getNavigationPayload();

    if (currentPayload && currentPayload.url !== window.location.href) {
      const path = getCurrentPathName(baseUrl);
      dispatch(reportNavigation({ id: path, path, source: 'website' }));
    }

    setNavigationPayload();

    const interval = setInterval(() => {
      const value = getNavigationPayload();
      if (!value) {
        setNavigationPayload();
        return;
      }

      if (value.url !== window.location.href) {
        const path = getCurrentPathName(baseUrl);
        dispatch(reportNavigation({ id: path, path, source: 'website' }));
        setNavigationPayload();
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch, baseUrl]);
};
